import React, { useRef } from 'react';

import { AlertDialog, Button } from '@rbilabs/universal-components';

import { ErrorText } from 'components/checkout-errors-modal/checkout-error-cell/styled';
import { StyledHeader } from 'components/checkout-errors-modal/styled';
import { AlertDialogEventLogger } from 'components/dialog/alert-dialog-event-logger';
import { t } from 'state/intl/translations';

type CartSelectionRequiredModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const CartSelectionRequiredModal = ({
  isOpen,
  onClose,
}: CartSelectionRequiredModalProps) => {
  const cancelRef = useRef(null);

  if (!isOpen) {
    return null;
  }

  const headerText = t('invalidCart', 'Invalid cart');
  const messageText = t(
    'cartSelectionRequiredToContinue',
    'Please add an item, a meal, an offer, or a reward to continue.'
  );

  return (
    <AlertDialogEventLogger
      testID="cart-selection-required-dialog"
      modalAppearanceEventMessage="Cart selection required"
      modalAppearanceHeader={headerText}
      modalAppearanceMessage={messageText}
      isErrorModal
      leastDestructiveRef={cancelRef}
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
    >
      <AlertDialog.Content>
        <AlertDialog.Header>
          <StyledHeader variant="headerTwo">{headerText}</StyledHeader>
        </AlertDialog.Header>
        <AlertDialog.Body>
          <ErrorText>{messageText}</ErrorText>
        </AlertDialog.Body>
        <AlertDialog.Footer>
          <Button width="full" onPress={onClose} testID="cart-selection-required-ok">
            {t('okay')}
          </Button>
        </AlertDialog.Footer>
      </AlertDialog.Content>
    </AlertDialogEventLogger>
  );
};
